import EditableFormattedMessage from "./EditableFormattedMessage";
import messagesData from "../lang/preferences";

export default function WorkplaceValuesPages({ messages, locale, updateMessage, graph, keyPage, code, datePassed }) {
  return (
    <div className="PageCharts-chart">
      <div className="header-logo-box">
      </div>
      <div className="report-alt-page">
        <h1>
          <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_VALUEPREF_TITLE" messages={messages} updateMessage={updateMessage} />
          <span className="inline font-16">
            {" "}
            - <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="DEFINITIONS" messages={messages} updateMessage={updateMessage} />
          </span>
        </h1>
        <br />
        <table className="scope-table-fullwidth">
          <tbody>
            {/* Enjoy Work */}
            <tr>
              <td className="scope-table-col">
                <b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_ENJOY_WORK" messages={messages} updateMessage={updateMessage} />
                </b>
              </td>
            </tr>
            <tr>
              <td className="scope-table-col">
                <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_ENJOY_WORK_DESC" messages={messages} updateMessage={updateMessage} />
              </td>
            </tr>
            {/* Leadership */}
            <tr>
              <td className="scope-table-col">
                <b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_LEADERSHIP" messages={messages} updateMessage={updateMessage} />
                </b>
              </td>
            </tr>
            <tr>
              <td className="scope-table-col">
                <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_LEADERSHIP_DESC" messages={messages} updateMessage={updateMessage} />
              </td>
            </tr>
            {/* Job Security */}
            <tr>
              <td className="scope-table-col">
                <b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_JOB_SECURITY" messages={messages} updateMessage={updateMessage} />
                </b>
              </td>
            </tr>
            <tr>
              <td className="scope-table-col">
                <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_JOB_SECURITY_DESC" messages={messages} updateMessage={updateMessage} />
              </td>
            </tr>
            {/* Intellectual Stimulation */}
            <tr>
              <td className="scope-table-col">
                <b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_INTELLECTUAL_STIMULATION" messages={messages} updateMessage={updateMessage} />
                </b>
              </td>
            </tr>
            <tr>
              <td className="scope-table-col">
                <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_INTELLECTUAL_STIMULATION_DESC" messages={messages} updateMessage={updateMessage} />
              </td>
            </tr>
            {/* Salary */}
            <tr>
              <td className="scope-table-col">
                <b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_SALARY" messages={messages} updateMessage={updateMessage} />
                </b>
              </td>
            </tr>
            <tr>
              <td className="scope-table-col">
                <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_SALARY_DESC" messages={messages} updateMessage={updateMessage} />
              </td>
            </tr>
            {/* Task Variability */}
            <tr>
              <td className="scope-table-col">
                <b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_TASK_VARIABILITY" messages={messages} updateMessage={updateMessage} />
                </b>
              </td>
            </tr>
            <tr>
              <td className="scope-table-col">
                <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="SCOPE_REPORT_TASK_VARIABILITY_DESC" messages={messages} updateMessage={updateMessage} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="pdf-footer">
        <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="PAGE" messages={messages} updateMessage={updateMessage} /> {keyPage + 1}
        <div className="pdf-footer-separator">
          <b>
            <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="CANDIDATE" messages={messages} updateMessage={updateMessage} />
          </b>
        </div>{" "}
        {code}
        <div className="pdf-footer-separator">
          <b>
            <EditableFormattedMessage keys={messagesData} locale={locale} msgKey="TEST_DATE" messages={messages} updateMessage={updateMessage} />
          </b>{" "}
          {datePassed}
        </div>
      </div>
    </div>
  );
}